<template>
    <a-layout class="component_layout group_chat">
        <a-alert
            :message="
                `在企业微信APP中发起群聊，创建企业微信群并“同步群列表”${
                    mark ? '；同步成功后，进行下一步。' : '。'
                }`
            "
            type="info"
            v-if="type === 'list'"
        />
        <a-layout-header class="component_header group_chat_header">
            <a-row type="flex" justify="space-between" align="middle" style="height: 64px">
                <a-form layout="inline">
                    <a-form-item label="群名称" v-if="!showSearch">
                        <a-input
                            v-model="searchData.groupName"
                            placeholder="群名称"
                            allowClear
                            @change="groupNameChange"
                        />
                    </a-form-item>
                    <a-form-item v-if="!showSearch">
                        <a-button :type="mark ? '' : 'primary'" @click="search">搜索</a-button>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="link" @click="showSearch = true">更多搜索条件</a-button>
                    </a-form-item>
                </a-form>
                <a-space v-if="type === 'list'">
                    <a-popconfirm
                        title="同步企业微信群数据，一天同步一次"
                        placement="bottom"
                        ok-text="立即同步"
                        cancel-text="暂不同步"
                        @confirm="toSync"
                    >
                        <a-button icon="sync">同步群列表</a-button>
                    </a-popconfirm>
                    <a-button @click="init">刷新</a-button>
                </a-space>
            </a-row>
        </a-layout-header>
        <a-layout-content class="component_content group_chat_content">
            <a-table
                :columns="columns"
                :data-source="dataList"
                :pagination="pagination"
                :loading="loading"
                :row-key="(record) => record.chatId"
                :customRow="type === 'list' ? null : rowClick"
                :rowSelection="
                    type === 'list'
                        ? null
                        : {
                              type,
                              getCheckboxProps: (record) => ({
                                  props: {
                                      disabled: allSelectKey.includes(record.chatId)
                                  }
                              }),
                              selectedRowKeys: selectKeys,
                              onChange: selectChange
                          }
                "
                @change="tableChange"
                :class="`group_chat_table_list ${mark ? 'mark' : ''}`"
            >
                <template slot="owner" slot-scope="text, record">
                    <openData type="userName" :openid="record.owner"></openData>
                </template>
                <template slot="action" slot-scope="text, record">
                    <a-button-group size="small">
                        <a-button type="link" @click="toDetail(record)">详情</a-button>
                    </a-button-group>
                </template>
            </a-table>
        </a-layout-content>
        <contactsModal
            ref="contacts"
            :title="['选择群主', '已选择的群主']"
            type="single"
            :selectKey="searchData.owner"
            @change="contactsChange"
        ></contactsModal>
        <a-modal
            title="搜索"
            :visible="showSearch"
            wrapClassName="group_search"
            :footer="null"
            @cancel="showSearch = false"
        >
            <a-form>
                <a-form-item label="群名称">
                    <a-input
                        v-model="searchData.groupName"
                        placeholder="群名称"
                        allowClear
                        @change="groupNameChange"
                    />
                </a-form-item>
                <a-form-item label="群主">
                    <a-button @click="toOpenContacts" v-if="searchData.owner.length === 0">
                        请选择
                    </a-button>
                    <a-select
                        mode="multiple"
                        v-model="searchData.owner"
                        :open="false"
                        :max-tag-count="2"
                        placeholder="请选择"
                        allow-clear
                        v-else
                        @click.native="toOpenContacts"
                        @change="contactsChange"
                    >
                        <a-select-option v-for="item in searchData.owner" :key="item">
                            <openData type="userName" :openid="item"></openData>
                        </a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="创建时间">
                    <a-range-picker
                        v-model="dateTime"
                        allow-clear
                        @change="dateTimeChange"
                    ></a-range-picker>
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" @click="search">搜索</a-button>
                </a-form-item>
            </a-form>
        </a-modal>
        <a-modal
            title="群详情"
            :width="960"
            :visible="showDetail"
            wrapClassName="group_chat_detail"
            :footer="null"
            @cancel="showDetail = false"
        >
            <a-space direction="vertical">
                <a-descriptions :column="4">
                    <a-descriptions-item label="群名称">{{ detailData.name }}</a-descriptions-item>
                    <a-descriptions-item label="群主">
                        <openData type="userName" :openid="detailData.owner"></openData>
                    </a-descriptions-item>
                    <a-descriptions-item label="群人数">
                        {{ detailData.number }}
                    </a-descriptions-item>
                    <a-descriptions-item label="群创建时间">
                        {{ detailData.createTime }}
                    </a-descriptions-item>
                    <a-descriptions-item label="群公告" :span="4">
                        {{ detailData.notice }}
                    </a-descriptions-item>
                </a-descriptions>
                <a-table
                    :columns="memberColumns"
                    :data-source="detailData.members"
                    :pagination="false"
                    :row-key="(record) => record.userId"
                >
                    <template slot="userId" slot-scope="text, record">
                        <a-space size="small">
                            <span v-if="record.name">{{ record.name }}</span>
                            <openData type="userName" :openid="record.userId" v-else></openData>
                            <span style="color:#1890ff;" v-if="record.type === 1"></span>
                            <span style="color:#87d068;" v-else-if="record.type === 2">@微信</span>
                            <span style="color:gold;" v-else>
                                {{ `@${record.corpName || '企业微信'}` }}
                            </span>
                        </a-space>
                    </template>
                    <template slot="joinScene" slot-scope="text, record">
                        <span v-if="text === 1">由成员直接邀请入群</span>
                        <span v-else-if="text === 2">由成员通过邀请链接入群</span>
                        <span v-else>通过扫描群二维码入群</span>
                    </template>
                </a-table>
            </a-space>
        </a-modal>
    </a-layout>
</template>

<script>
import _ from 'lodash';
import api from '@/apis';
import openData from '@/components/group/openData';
import contactsModal from '@/components/group/contactsModal';
export default {
    components: {
        openData,
        contactsModal
    },
    props: {
        type: {
            type: String,
            default: ''
        },
        mark: {
            type: Boolean,
            default: false
        },
        allSelectKey: {
            type: Array,
            default: () => []
        },
        selectKey: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            loading: false,
            showSearch: false,
            showDetail: false,
            dateTime: [],
            selectKeys: [],
            rowSelection: {},
            pagination: {
                total: 0,
                pageSize: 10
            },
            searchData: {
                page: 1,
                owner: []
            },
            detailData: {
                members: []
            },
            columns: [
                {
                    title: '群名称',
                    key: 'name',
                    dataIndex: 'name'
                },
                {
                    title: '群人数',
                    key: 'number',
                    dataIndex: 'number'
                },
                {
                    title: '群主',
                    key: 'owner',
                    scopedSlots: { customRender: 'owner' }
                },
                {
                    title: '创建时间',
                    key: 'createTime',
                    width: 150,
                    dataIndex: 'createTime'
                }
            ],
            memberColumns: [
                {
                    title: '群成员',
                    key: 'userId',
                    scopedSlots: { customRender: 'userId' }
                },
                {
                    title: '入群方式',
                    key: 'joinScene',
                    scopedSlots: { customRender: 'joinScene' }
                },
                {
                    title: '入群时间',
                    key: 'joinTime',
                    width: 150,
                    dataIndex: 'joinTime'
                }
            ],
            dataList: []
        };
    },
    mounted() {
        switch (this.type) {
            case 'list':
                this.columns.push({
                    title: '',
                    key: 'action',
                    width: 80,
                    scopedSlots: { customRender: 'action' }
                });
                break;
            case 'radio':
                this.selectKeys = this.selectKey;
                break;
            case 'checkbox':
                this.selectKeys = this.selectKey;
                break;
        }
        this.init();
    },
    methods: {
        open(type) {
            switch (type) {
                case 'list':
                    this.columns.push({
                        title: '',
                        key: 'action',
                        width: 80,
                        scopedSlots: { customRender: 'action' }
                    });
                    break;
                case 'radio':
                    this.selectKeys = this.selectKey;
                    break;
                case 'checkbox':
                    this.selectKeys = this.selectKey;
                    break;
            }
            this.init();
        },
        // 初始数据
        async init() {
            this.loading = true;
            try {
                const res = await api.getGroup({ page: this.searchData.page });
                if (res.code !== 0) return;
                this.loading = false;
                this.pagination.total = res.count;
                this.pagination.pageSize = res.pageSize;
                this.dataList = res.rows.map((item) => {
                    const row = item;
                    row.disabled = this.allSelectKey.includes(item.chatId);
                    return row;
                });
            } catch (err) {
                console.log(err);
            }
        },
        // 搜索
        async search() {
            this.loading = true;
            let data = {};
            data.page = this.searchData.page;
            if (this.searchData.groupName) data.groupName = this.searchData.groupName;
            if (this.searchData.owner.length > 0) data.owner = this.searchData.owner;
            if (this.searchData.startTime) data.startTime = this.searchData.startTime;
            if (this.searchData.endTime) data.endTime = this.searchData.endTime;
            try {
                const res = await api.postGroupSearch(data);
                if (res.code !== 0) return;
                this.loading = false;
                this.showSearch = false;
                this.pagination.total = res.count;
                this.pagination.pageSize = res.pageSize;
                this.dataList = res.rows.map((item) => {
                    const row = item;
                    row.disabled = this.allSelectKey.includes(item.chatId);
                    return row;
                });
            } catch (err) {
                console.log(err);
            }
        },
        // 同步
        async toSync() {
            try {
                const res = await api.postGroupSync();
                if (res.code !== 0) return;
                this.$message.success('开始同步，稍后请手动刷新页面');
            } catch (err) {
                console.log(err);
            }
        },
        // 弹框
        toOpenContacts() {
            this.$refs.contacts.open();
        },
        // 操作
        async toDetail(item) {
            try {
                const res = await api.getGroupDetail({ chatId: item.chatId });
                if (res.code !== 0) return;
                this.detailData.members = res.members;
                this.detailData.name = item.name;
                this.detailData.owner = item.owner;
                this.detailData.number = item.number;
                this.detailData.notice = item.notice;
                this.detailData.createTime = item.createTime;
                this.showDetail = true;
            } catch (err) {
                console.log(err);
            }
        },
        tableChange(e) {
            this.searchData.page = e.current;
            this.search();
        },
        groupNameChange(e) {
            if (e.target.value) {
                this.searchData.groupName = e.target.value;
            } else {
                delete this.searchData.groupName;
                this.search();
            }
        },
        dateTimeChange(date, dateString) {
            if (_.compact(dateString).length > 0) {
                this.searchData.startTime = dateString[0];
                this.searchData.endTime = dateString[1];
            } else {
                delete this.searchData.startTime;
                delete this.searchData.endTime;
                this.search();
            }
        },
        contactsChange(e) {
            if (e.length > 0) {
                this.searchData.owner = e;
            } else {
                this.searchData.owner = [];
                this.search();
            }
        },
        selectChange(key, item) {
            this.selectKeys = key;
            this.selectData = {
                chatId: item[0].chatId,
                name: item[0].name
            };
            this.$emit('change', this.selectData);
        },
        rowClick(record) {
            return {
                on: {
                    click: () => {
                        if (!record.disabled) this.selectChange([record.chatId], [record]);
                    }
                }
            };
        }
    }
};
</script>

<style>
/* .group_chat .group_chat_table_list .ant-table-body {
    max-height: calc(100vh - 477px) !important;
    overflow-y: auto !important;
}
.group_chat .group_chat_table_list.mark .ant-table-body {
    max-height: calc(100vh - 637px) !important;
    overflow-y: auto !important;
} */
</style>
